<template>
    <div>
        <b-navbar type="light" toggleable="sm" class="shadow-sm module-navbar">
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse id="nav_dropdown_collapse" is-nav>
                <b-navbar-nav v-if="isShowActions">
                    <b-nav-item
                        v-if="
                            data.filterDateOption &&
                            $route.name != 'report_dashboard' &&
                            parseInt($route.params.id) !=
                                CREPORT.TYPE.ACCOUNTS_RECEIVABLE
                        "
                        href
                        @click.prevent="filterDateRange"
                    >
                        <i class="cus-date-edit"></i>Filter
                    </b-nav-item>

                    <b-nav-item
                        v-if="
                            parseInt($route.params.id) ==
                                CREPORT.TYPE.ACCOUNTS_RECEIVABLE &&
                            $route.name != 'report_dashboard'
                        "
                        href
                        @click.prevent="filterStatements"
                    >
                        <i class="cus-date-edit"></i>Filter
                    </b-nav-item>

                    <b-nav-item
                        v-if="
                            isUseFilterEngagedReportModal &&
                            $route.name != 'report_dashboard'
                        "
                        href
                        @click.prevent="filterEngagedReport"
                    >
                        <i class="cus-date-edit"></i>Filter
                    </b-nav-item>

                    <b-nav-item
                        v-if="
                            parseInt($route.params.id) ==
                                CREPORT.TYPE.PETCARE_CLIENT_LIST &&
                            $route.name != 'report_dashboard'
                        "
                        href
                        @click.prevent="filterPetCareUser"
                    >
                        <i class="cus-date-edit"></i>Filter
                    </b-nav-item>

                    <b-nav-item-dropdown
                        v-if="
                            parseInt($route.params.id) ==
                                CREPORT.TYPE.ACCOUNTS_RECEIVABLE &&
                            $route.name != 'report_dashboard'
                        "
                    >
                        <template slot="button-content">
                            <i class="famfamfam-silk cus-page-attach"></i>
                            Statements
                        </template>
                        <b-dropdown-item
                            @click.prevent="openModalStatements('EMAIL')"
                        >
                            <i class="cus-email"></i>
                            Email statements to selected
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click.prevent="openModalStatements('PRINT')"
                        >
                            <i class="cus-printer"></i>
                            Print statements for selected
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown
                        v-if="
                            isReminderReport &&
                            $route.name != 'report_dashboard'
                        "
                    >
                        <template slot="button-content">
                            <i class="famfamfam-silk cus-lightning"></i>
                            Actions
                        </template>
                        <b-dropdown-item
                            @click.prevent="reminderAction('print')"
                        >
                            <i class="cus-printer"></i>
                            Print cards for selected
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click.prevent="reminderAction('resend')"
                        >
                            <i class="cus-email-go"></i>
                            Resend selected
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click.prevent="reminderAction('logcall')"
                        >
                            <i class="cus-book"></i>
                            Log call for selected
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item
                        v-if="
                            _hasAccess('report.export') &&
                            data.exportOptionCsvOnly
                        "
                        href
                        @click.prevent="exportReport(0)"
                        :disabled="isExporting"
                    >
                        <spinner v-if="isExporting" />
                        <i v-else class="famfamfam-silk cus-page-white-put"></i
                        >Export Report
                    </b-nav-item>

                    <b-nav-item
                        v-else-if="
                            _hasAccess('report.export') &&
                            data.isGreyOutButton &&
                            data.exportOption &&
                            $route.name != 'report_dashboard' &&
                            (parseInt($route.params.id) ==
                                CREPORT.TYPE.ACTIVE_ENGAGED_PATIENT ||
                                parseInt($route.params.id) ==
                                    CREPORT.TYPE.NEW_ENGAGED_CLIENTS ||
                                parseInt($route.params.id) ==
                                    CREPORT.TYPE.DELETED_TRANSACTIONS)
                        "
                        v-b-tooltip.hover.bottom
                        title="No Data to Export"
                        href
                        disabled
                    >
                        <i
                            class="famfamfam-silk cus-page-white-put disabled-icon"
                        ></i>
                        <span class="text-muted">Export</span>
                    </b-nav-item>

                    <b-nav-item-dropdown
                        v-else-if="
                            _hasAccess('report.export') &&
                            data.exportOption &&
                            $route.name != 'report_dashboard' &&
                            (parseInt($route.params.id) ==
                                CREPORT.TYPE.ACTIVE_ENGAGED_CLIENT_LIST ||
                                parseInt($route.params.id) ==
                                    CREPORT.TYPE.ACTIVE_ENGAGED_PATIENT ||
                                parseInt($route.params.id) ==
                                    CREPORT.TYPE.NEW_ENGAGED_CLIENTS)
                        "
                        :disabled="isExporting"
                    >
                        <template slot="button-content">
                            <spinner v-if="isExporting" />
                            <i
                                v-else
                                class="famfamfam-silk cus-page-white-put"
                            ></i>
                            Export
                        </template>
                        <div>
                            <b-dropdown-item
                                v-for="(item, index) in exportOptions"
                                :key="index"
                                @click.prevent="
                                    exportOptionalReport(item.function_code)
                                "
                                href="#0"
                            >
                                <i class="famfamfam-silk cus-page-white-put"></i
                                >{{ item.text }}
                            </b-dropdown-item>
                        </div>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown
                        v-else-if="
                            _hasAccess('report.export') &&
                            data.exportOption &&
                            $route.name != 'report_dashboard' &&
                            parseInt($route.params.id) ==
                                CREPORT.TYPE.PETCARE_CLIENT_LIST
                        "
                        :disabled="isExporting"
                    >
                        <template slot="button-content">
                            <spinner v-if="isExporting" />
                            <i
                                v-else
                                class="famfamfam-silk cus-page-white-put"
                            ></i>
                            Export
                        </template>
                        <div>
                            <b-dropdown-item
                                @click.prevent="exportReport(0)"
                                href="#0"
                            >
                                <i class="famfamfam-silk cus-page-white-put"></i
                                >Download
                            </b-dropdown-item>
                        </div>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown
                        v-else-if="
                            _hasAccess('report.export') &&
                            data.exportOption &&
                            $route.name != 'report_dashboard'
                        "
                        :disabled="isExporting"
                    >
                        <template slot="button-content">
                            <spinner v-if="isExporting" />
                            <i
                                v-else
                                class="famfamfam-silk cus-page-white-put"
                            ></i>
                            Export
                        </template>
                        <div
                            v-if="
                                parseInt($route.params.id) ==
                                CREPORT.TYPE.INVENTORY_VALUE_COGS
                            "
                        >
                            <b-dropdown-item
                                @click.prevent="exportReport(2)"
                                href="#0"
                            >
                                <i class="famfamfam-silk cus-page-white-put"></i
                                >Download
                            </b-dropdown-item>
                            <b-dropdown-item
                                @click.prevent="exportReport(3)"
                                href="#0"
                            >
                                <i class="famfamfam-silk printer"></i>Print
                            </b-dropdown-item>
                        </div>
                        <div
                            v-else-if="
                                parseInt($route.params.id) ==
                                CREPORT.TYPE.OUT_OF_PERIOD_ADJUSTMENTS
                            "
                        >
                            <b-dropdown-item
                                @click.prevent="exportReport(0)"
                                href="#0"
                            >
                                <i class="famfamfam-silk cus-page-white-put"></i
                                >Download
                            </b-dropdown-item>
                        </div>
                        <div v-else>
                            <dropdown-nested
                                v-if="isExportOptionsReport"
                                :title="{
                                    text: 'Download',
                                    icon: 'famfamfam-silk cus-page-white-put'
                                }"
                                :list="exportOptions"
                                @trigger-function="exportOptionalReport"
                            />
                            <b-dropdown-item
                                v-else
                                @click.prevent="exportReport(0)"
                                href="#0"
                            >
                                <i class="famfamfam-silk cus-page-white-put"></i
                                >Download for all
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="isReminderDetails"
                                @click.prevent="exportReport(0, true)"
                                href="#0"
                            >
                                <i class="famfamfam-silk cus-page-white-put"></i
                                >Download for selected
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="
                                    parseInt($route.params.id) ==
                                    CREPORT.TYPE.ACTIVE_CLIENT_LIST
                                "
                                @click.prevent="exportReport(3)"
                                href="#0"
                            >
                                <i class="famfamfam-silk printer"></i>Print
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-else
                                @click.prevent="exportReport(1)"
                                href="#0"
                            >
                                <i class="famfamfam-silk printer"></i>Print for
                                all
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="isReminderDetails"
                                @click.prevent="exportReport(1, true)"
                                href="#0"
                            >
                                <i class="famfamfam-silk printer"></i>Print for
                                selected
                            </b-dropdown-item>
                        </div>
                    </b-nav-item-dropdown>

                    <b-nav-item
                        v-if="
                            $route.name != 'report_dashboard' &&
                            parseInt($route.params.id) !=
                                CREPORT.TYPE.INVENTORY_VALUE_COGS &&
                            data.refreshOption &&
                            data.isGreyOutButton
                        "
                        v-b-tooltip.hover.bottom
                        title="No Data to Refresh"
                        href
                        disabled
                    >
                        <i class="cus-arrow-refresh disabled-icon"></i
                        ><span class="text-muted">Refresh</span>
                    </b-nav-item>
                    <b-nav-item
                        v-else-if="
                            $route.name != 'report_dashboard' &&
                            parseInt($route.params.id) !=
                                CREPORT.TYPE.INVENTORY_VALUE_COGS &&
                            data.refreshOption
                        "
                        href
                        @click.prevent="refreshReport"
                    >
                        <i class="cus-arrow-refresh"></i>Refresh
                    </b-nav-item>
                    <b-nav-item class="invisible" href>
                        <i></i>Spacer
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        {{ data.statuses }}
        <router-view
            :data="data"
            :dialogs="dialogs"
            ref="routerView"
        ></router-view>
        <filterDateRange ref="filterDateRangeWindow" :data="data">
            <template v-slot:extra-content v-if="isTimesheetReport">
                <b-form-group label="" label-cols="3" class="p-0">
                    <label class="checkbox flex">
                        <input
                            class="mr-1"
                            type="checkbox"
                            name="isIncludedInactive"
                            v-model="data.isIncludedInactive"
                        />
                        <span class="fw-normal">Include inactive staff</span>
                    </label>
                </b-form-group>
                <div></div>
            </template>
        </filterDateRange>
        <ReminderActions ref="reminderActionModal" />
        <ModalStatements ref="modalStatements" />
        <FilterStatements ref="filterStatements" />
        <FilterEngagedReport
            v-if="isUseFilterEngagedReportModal"
            ref="filterEngagedReport"
            :data="data"
        />
        <FilterPetCareUser
            ref="filterPetCareUser"
            :data="{ show: petcareReport.is_active_users }"
        />
        <scroll-to-top-scroll ref="scrollToTopScroll" />
    </div>
</template>
<script>
import FilterDateRange from "./module/filter-date-range.vue";
import ReminderActions from "./module/reminder-actions.vue";
import ModalStatements from "./module/accounts-receivable-statements";
import FilterStatements from "./module/filter-statements";
import FilterEngagedReport from "./module/filter-engaged-report";
import ScrollToTopScroll from "@/components/commons/scroll-to-top";
import Spinner from "@/components/elements/spinner";
import CREPORT from "@/constants/report";
import DropdownNested from "@/components/elements/dropdown/dropdown-nested";
import { merge, map, omit } from "lodash";
import FilterPetCareUser from "@/module/report/module/filter-petcare-user";

const DISPLAY_MONTHLY = "month";

export default {
    components: {
        FilterDateRange,
        ReminderActions,
        ModalStatements,
        FilterStatements,
        FilterEngagedReport,
        Spinner,
        ScrollToTopScroll,
        DropdownNested,
        FilterPetCareUser
    },
    data() {
        return {
            resources: {},
            CREPORT: CREPORT,
            isExporting: false,
            data: {
                isHideActions: false,
                filterDateOption: true,
                exportOption: true,
                exportOptionCsvOnly: false,
                refreshOption: true,
                from: moment().tz(this._timeZone),
                to: moment().tz(this._timeZone),
                start: moment().tz(this._timeZone),
                end: moment().tz(this._timeZone),
                asOf: moment().tz(this._timeZone),
                statuses: "",
                module: [
                    {
                        value: 1,
                        text: "Schedule"
                    }
                ],
                ignoreFormat: false,
                datePickerRange: false,
                datePickerOptions: {
                    format: null
                },
                isFilterDateMonthOnly: false,
                category: [],
                exportOptionType: "",
                filterByOptionDefault: DISPLAY_MONTHLY,
                isGreyOutButton: false,
                isIncludedInactive: false
            },
            petcareReport: {
                is_active_users: null,
                interval_month: null,
                to: null
            }
        };
    },
    created() {},
    computed: {
        isUseFilterEngagedReportModal() {
            return (
                parseInt(this.$route.params.id) ==
                    CREPORT.TYPE.ACTIVE_ENGAGED_CLIENT_LIST ||
                parseInt(this.$route.params.id) ==
                    CREPORT.TYPE.ACTIVE_ENGAGED_PATIENT
            );
        },
        dialogs() {
            return this.$refs;
        },
        isReminderReport() {
            return (
                parseInt(this.$route.params.id) ==
                    CREPORT.TYPE.REMINDERS_DETAIL ||
                this.$route.params.id == "reminder"
            );
        },
        isReminderDetails() {
            return (
                parseInt(this.$route.params.id) ==
                    CREPORT.TYPE.REMINDERS_DETAIL ||
                this.$route.params.id == "reminder"
            );
        },
        isExportOptionsReport() {
            const reportIds = [
                CREPORT.TYPE.SALES_BY_PROVIDER_DETAILS,
                CREPORT.TYPE.PAYMENT_BY_PROVIDER,
                CREPORT.TYPE.PRODUCTION_CREDIT_BY_SALES,
                CREPORT.TYPE.ACTIVE_ENGAGED_CLIENT_LIST,
                CREPORT.TYPE.ACTIVE_ENGAGED_PATIENT,
                CREPORT.TYPE.PRODUCTION_CREDIT_BY_PAYMENTS,
                CREPORT.TYPE.NEW_ENGAGED_CLIENTS,
                CREPORT.TYPE.APPOINTMENT_DURATION
            ];
            return reportIds.includes(parseInt(this.$route.params.id));
        },
        isTimesheetReport() {
            return parseInt(this.$route.params.id) == CREPORT.TYPE.TIME_SHEETS;
        },
        exportOptions() {
            if (this.isExportOptionsReport) {
                return [
                    {
                        text: "Summary",
                        function_code: "S",
                        icon: "famfamfam-silk cus-page-white-put"
                    },
                    {
                        text: "Detail",
                        function_code: "D",
                        icon: "famfamfam-silk cus-page-white-put"
                    },
                    {
                        text: "Complete",
                        function_code: "F",
                        icon: "famfamfam-silk cus-page-white-put"
                    }
                ];
            } else {
                return false;
            }
        },
        isShowActions() {
            return !this.data.isHideActions;
        }
    },
    mounted() {
        this.$root.$on("report-filter-date-range:open", () => {
            this.filterDateRange();
        });
        this.$root.$on("report-filter-date-range:refresh", params => {
            let merged = null;
            let reportId = parseInt(this.$route.params.id);

            if (this.isReminderDetails) {
                // Omit is to remove the property listed
                // This is due to issue where this.data has patientStatus {code:1, label: "Active", code:2, label: "Deceased"}, when merged, it value become {code:1, label: "Active", code:1, label: "Active"}
                // Now sure why, so to fix this issue quickly, I will just use the patientStatus from params instead
                // Later on we will use  merged = cloneDeep(this.data); and update each params one by one
                merged = merge(omit(this.data, ["patientStatus"]), params);

                // reset selection after filtering
                this.$refs.routerView.resetCheckBoxes();
            } else {
                merged = merge(this.data, params);
            }

            if (params) {
                switch (reportId) {
                    case CREPORT.TYPE.CONTROLLED_SUBSTANCE_LOG:
                        // replace instead of combine
                        merged.provider = params.provider;
                        merged.items = params.items;
                        break;

                    // prettier-ignore
                    case CREPORT.TYPE.REMINDERS_DETAIL:
                        merged.remindersCategoryMode = params.remindersCategoryMode;
                        merged.remindersCategory = params.remindersCategory;
                        merged.remindersType = params.remindersType;
                        merged.remindersNextVisit = params.remindersNextVisit;
                        merged.patientStatus = params.patientStatus;
                        break;

                    // display export option even when page is still fetching data
                    case CREPORT.TYPE.SALES_BY_PROVIDER_DETAILS:
                        this.data.exportOption = true;
                        break;

                    case CREPORT.TYPE.NEW_ENGAGED_CLIENTS:
                        merged.home_location_id = params.home_location_id;
                        break;

                    default:
                        break;
                }
            }

            this.data = merged;
        });

        this.$root.$on("active_engaged_client_list:load", params => {
            let merged = merge(this.data, params);
            merged.home_location_id = params.home_location_id;
        });

        this.$root.$on("active_engaged_patient:load", params => {
            let merged = merge(this.data, params);
            merged.home_location_id = params.home_location_id;
        });

        this.$root.$on("petcare_client_list:toggle", data => {
            this.petcareToggleFilter(data);
        });
    },
    beforeDestroy: function () {
        let self = this;
        self.$root.$off("report-filter-date-range:open");
    },
    methods: {
        openModalStatements(type) {
            let ids =
                this.$store.state.report.accountsReceivable.selectedClientIds ||
                [];

            if (ids.length > 0) {
                this.$refs.modalStatements.open({
                    type: type
                });
            } else {
                this._message("No record selected", "danger");
            }
        },
        reminderAction(task) {
            let rawCheckedItems = sessionStorage.getItem(
                "reminders_detail_checked"
            );
            let items = [];

            if (rawCheckedItems) {
                items = JSON.parse(rawCheckedItems);
            }

            if (items.length === 0) {
                this._message("No reminder selected", "danger");
                return; // stop execution
            }

            let taskMap = {
                print: "PRINT",
                resend: "RESEND",
                logcall: "LOGCALL"
            };

            this.$refs.reminderActionModal.open({
                type: taskMap[task],
                items
            });
        },
        filterDateRange() {
            this.$refs["filterDateRangeWindow"].open(this.data);
        },
        filterStatements() {
            this.$refs.filterStatements.open();
        },
        filterEngagedReport() {
            this.$refs.filterEngagedReport.open();
        },
        filterPetCareUser() {
            this.$refs.filterPetCareUser.open();
        },
        exportOptionalReport(type) {
            this.data.exportOptionType = type;
            this.exportReport(0);
        },
        exportReport(option, selected = false) {
            this.isExporting = true;
            let from = moment().startOf("week").tz(this._timeZone).unix();
            let to = moment().endOf("day").tz(this._timeZone).unix();
            let parameters = [];
            let paramsId =
                this.$route.name == "custom_report"
                    ? this.$route.params.id
                    : parseInt(this.$route.params.id);
            let httpMethod = "GET";

            if (this.$refs.details) {
                console.log(this.$refs.details.statuses);
            }

            if (this.data.start && this.data.end) {
                from = moment(this.data.start)
                    .startOf("day")
                    .tz(this._timeZone)
                    .unix();
                to = moment(this.data.end)
                    .endOf("day")
                    .tz(this._timeZone)
                    .unix();
            }

            if (this.data.from && this.data.to) {
                from = this.data.from;
                to = this.data.to;
            }

            // accounts receivable

            if (paramsId === CREPORT.TYPE.ACCOUNTS_RECEIVABLE) {
                let asOf = this.$store.state.report.accountsReceivable.filter.asOf; // prettier-ignore

                if (!asOf) {
                    to = moment().tz(this._timeZone).endOf("day").unix();
                } else {
                    to = moment
                        .tz(asOf, this.getDateFormat(), this._timeZone)
                        .endOf("day")
                        .unix();
                }
            }

            parameters = {
                from: from,
                to: to,
                business_id: this.$root.setting.business_id,
                user_id: this.$root.currentActor.id,
                timezone: this._timeZone
            };

            if (selected) {
                let rawCheckedItems = sessionStorage.getItem(
                    "reminders_detail_checked"
                );
                let items = [];

                if (rawCheckedItems) {
                    items = JSON.parse(rawCheckedItems);
                }

                if (items.length === 0) {
                    this._message("No reminder selected", "danger");
                    this.isExporting = false;
                    return; // stop execution
                }
                httpMethod = "POST";

                let reminderIds = [];
                for (let item of items) {
                    reminderIds.push(item.split(",")[0]);
                }
                parameters["reminder_ids"] = reminderIds;
                parameters["next_visit"] = this.data.remindersNextVisit ?? 1;
            }

            if (this.data.isShowItemClass && this.data.itemClass) {
                parameters["item_class"] = this.data.itemClass;
            }

            if (this.data.statuses) {
                parameters["status"] = this.data.statuses;
            }

            if (this.data.provider) {
                parameters["provider"] = this.data.provider.map(id => id.value);
            }

            if (this.data.isShowAsOf) {
                parameters["to"] = this.data.asOf
                    ? this.data.asOf.endOf("day").unix()
                    : moment().endOf("day").tz(this._timeZone).unix();
            }

            if (this.data.isShowItemStatus) {
                parameters["status"] = this.data.status;
            }

            if (this.data.isShowItemCategory) {
                parameters["category"] =
                    this.data.category.length > 0
                        ? JSON.stringify(this.data.category)
                        : [];
            }

            if (this.data.isShowModuleOption) {
                parameters["module"] = this.data.module.map(id => id.value);
                if (this.data.module) {
                    parameters["module"] = this.data.module.map(id => id.value);
                }
            }

            if (paramsId === CREPORT.TYPE.CONTROLLED_SUBSTANCE_LOG) {
                parameters["filter[controlledItemData]"] = "";
                parameters["filter[controlledProviderData]"] = "";

                if (this.data.items && this.data.items.length > 0) {
                    parameters["filter[controlledItemData]"] = this.data.items.map(item => ':' + item.raw_id); // prettier-ignore
                }

                if (this.data.provider && this.data.provider.length > 0) {
                    parameters["filter[controlledProviderData]"] = this.data.provider.map(provider => provider.value); // prettier-ignore
                }
            }

            if (paramsId === CREPORT.TYPE.ACCOUNTS_RECEIVABLE) {
                let {
                    totalDue,
                    exemptFlag
                } = this.$store.state.report.accountsReceivable.filter;

                parameters["total_due"] = totalDue;
                parameters["exempt_flag"] = exemptFlag;
            }

            if (paramsId === CREPORT.TYPE.RABIES_SUMMARY) {
                // rabies summary report
                httpMethod = "POST";
                const recordIds = this.$store.state.report.rabiesSummary
                    .selectedRecordIds;

                if (recordIds.length === 0) {
                    this._message("No records selected", "danger");
                    return;
                }

                parameters["record_ids"] = recordIds;
                parameters["city_option"] =
                    this.data.city && this.data.city.length > 0
                        ? map(this.data.city, "value")
                        : [];
                parameters["species_option"] =
                    this.data.species && this.data.species.length > 0
                        ? map(this.data.species, "value")
                        : [];
            }

            if (paramsId === CREPORT.TYPE.DIAGNOSIS_SUMMARY_LIST) {
                const hasDiagnosis =
                    this.data.diagnosis && this.data.diagnosis.length > 0;

                parameters["option"] = hasDiagnosis ? "1" : "0";
                parameters["values"] = hasDiagnosis
                    ? map(this.data.diagnosis, "value")
                    : [];
                parameters["status"] = this.data.diagnosisStatus;
                parameters["species"] =
                    this.data.species.length > 0
                        ? map(this.data.species, "value")
                        : [];
            }

            if (paramsId === CREPORT.TYPE.INVENTORY_LOG) {
                parameters["item_class"] = this.data.itemClass;
                parameters["items"] = this.data.items.map(item => item.raw_id);
                parameters["category"] = this.data.category
                    ? this.data.category
                    : [];
            }

            if (paramsId === CREPORT.TYPE.SALES_BY_PROVIDER_DETAILS) {
                parameters["item_class"] = this.data.itemClass;
                parameters["category"] = this.data.category
                    ? this.data.category
                    : [];
                if (this.data.provider) {
                    parameters["provider"] = this.data.provider.map(
                        provider => provider.value
                    );
                }
                parameters["filter_by_sales"] = this.data.categorySales;
                parameters["isFromExport"] = 1;
            }

            if (paramsId === CREPORT.TYPE.DELETED_TRANSACTIONS) {
                parameters["module"] = this.data.module.map(id => id.value);
                parameters["isFromExport"] = 1;
            }

            if (paramsId === CREPORT.TYPE.SALES_BY_PROVIDER_SUMMARY) {
                parameters["isFromExport"] = 1;
            }

            if (
                paramsId === CREPORT.TYPE.ACTIVE_ENGAGED_CLIENT_LIST ||
                paramsId === CREPORT.TYPE.ACTIVE_ENGAGED_PATIENT
            ) {
                parameters["to"] = this.data.to;
                parameters["interval_month"] = this.data.interval_month;
                parameters["home_location_id"] = this.data.home_location_id;
            }

            if (paramsId === CREPORT.TYPE.NEW_ENGAGED_CLIENTS) {
                parameters["to"] = this.data.to;
                parameters["home_location_id"] = this.data.home_location_id;
            }

            if (
                paramsId === CREPORT.TYPE.PRODUCTION_CREDIT_BY_PAYMENTS ||
                paramsId === CREPORT.TYPE.PRODUCTION_CREDIT_BY_SALES
            ) {
                parameters[
                    "all_sales_category"
                ] = this.data.isShowAllSalesCategory;
                parameters[
                    "include_refill_sales"
                ] = this.data.isIncludeRefillSales;
                parameters["category"] = this?.data?.category ?? [];
                parameters[
                    "exclude_eligibility_fee"
                ] = this.data.isExcludeEligibilityFee;
                if (this.data.provider) {
                    parameters["provider"] = this.data.provider.map(
                        provider => provider.value
                    );
                }
                parameters["item_class"] = this.data.itemClass;
            }

            if (paramsId === CREPORT.TYPE.PETCARE_CLIENT_LIST) {
                httpMethod = "GET";
                option = 0;

                parameters = {
                    exportType: "F"
                };
                if (this.petcareReport.is_active_users == 1) {
                    (parameters[
                        "interval_month"
                    ] = this.petcareReport.interval_month),
                        (parameters["to"] = this.petcareReport.to);
                }
            }

            // handle reminder report viewing from schedule tab
            if (this.$route.params.id === "reminder") {
                paramsId = CREPORT.TYPE.REMINDERS_DETAIL;
            }

            if (this.data.isCustomReport) {
                from = moment(this.data.start).tz(this._timeZone).unix();
                to = moment(this.data.end).tz(this._timeZone).unix();
                parameters["module"] = CREPORT.TYPE.CUSTOM_REPORT; // define as custom report
                parameters["from"] = from;
                parameters["to"] = to;
            }

            if (this.isExportOptionsReport) {
                parameters["exportType"] = this.data.exportOptionType;
            }

            if (this.data.filterBy) {
                parameters["filterBy"] = this.data.filterBy.value;
            }

            if (
                this.$store &&
                this.$store.state &&
                this.$store.state.report &&
                this.$store.state.report.timesheets &&
                this.$store.state.report.timesheets.isIncludedInactive
            ) {
                parameters["included_inactive"] = true;
            }

            switch (option) {
                case 1:
                    return this.$http({
                        method: httpMethod,
                        url:
                            process.env.BARRACUDA +
                            "report/pdf-request/" +
                            paramsId,
                        data: httpMethod === "POST" ? parameters : {},
                        params: httpMethod === "GET" ? parameters : {}
                    })
                        .then(response => {
                            if (response.status === 200) {
                                if (response.data.queue) {
                                    this._message(
                                        response.data.message,
                                        "info"
                                    );
                                } else if (
                                    response.data.response !== undefined
                                ) {
                                    let data = response.data.response.resource;
                                    if (data.path) {
                                        this._redirect(
                                            data.path + "?" + moment().unix(),
                                            true,
                                            500
                                        );
                                    }
                                } else {
                                    this._message(
                                        "No records available",
                                        "warning"
                                    );
                                }
                            }
                        })
                        .finally(() => {
                            this.isExporting = false;
                        });
                //-- Push generate csv report to queue and trigger task
                case 2:
                    return this.$http
                        .post(
                            process.env.BARRACUDA +
                                "report/gen-csv-report-queue/" +
                                paramsId,
                            parameters
                        )
                        .then(response => {
                            if (response.data.mode == 0) {
                                this._message(response.data.message, "info");
                            }
                        })
                        .finally(() => {
                            this.isExporting = false;
                        });
                //-- Push generate pdf report to queue and trigger task
                case 3:
                    return this.$http
                        .post(
                            process.env.BARRACUDA +
                                "report/gen-pdf-report-queue/" +
                                paramsId,
                            parameters
                        )
                        .then(response => {
                            if (response.data.mode == 0) {
                                this._message(response.data.message, "info");
                            }
                        })
                        .finally(() => {
                            this.isExporting = false;
                        });
                default:
                    return this.$http({
                        method: httpMethod,
                        url:
                            process.env.BARRACUDA +
                            "report/csv-request/" +
                            paramsId,
                        data: httpMethod === "POST" ? parameters : {},
                        params: httpMethod === "GET" ? parameters : {}
                    })
                        .then(response => {
                            if (response.status === 200) {
                                if (response.data.queue) {
                                    this._message(
                                        response.data.message,
                                        "info"
                                    );
                                } else if (
                                    response.data.response !== undefined
                                ) {
                                    let data = response.data.response.resource;
                                    if (data.ObjectURL) {
                                        this._redirect(
                                            data.ObjectURL,
                                            true,
                                            500
                                        );
                                    }
                                } else {
                                    this._message(
                                        "No records available",
                                        "warning"
                                    );
                                }
                            }
                        })
                        .finally(() => {
                            this.isExporting = false;
                        });
            }
        },
        refreshReport() {
            switch (parseInt(this.$route.params.id)) {
                case CREPORT.TYPE.ACTIVE_CLIENT_LIST:
                    this.$root.$emit("active_client_list:refresh");
                    break;
                case CREPORT.TYPE.ACTIVE_ENGAGED_CLIENT_LIST:
                    this.$root.$emit("active_engaged_client_list:refresh");
                    break;
                case CREPORT.TYPE.INVENTORY_SUMMARY:
                    this.$root.$emit("inventory_summary:refresh");
                    break;
                case CREPORT.TYPE.CONTROLLED_SUBSTANCE_LOG:
                    this.$root.$emit(
                        "controlled-substances-log:refresh",
                        this.data
                    );
                    break;
                case CREPORT.TYPE.EOD_RECONCILIATION:
                    this.$root.$emit("end-of-day-reconciliation:refresh");
                    break;
                case CREPORT.TYPE.SALES_BY_PROVIDER_DETAILS:
                    this.$root.$emit("sales-provider-detail:refresh");
                    break;
                case CREPORT.TYPE.IN_PROCESS_MEDICAL_NOTES:
                    this.$root.$emit("in_process_medical_notes:refresh");
                    break;
                case CREPORT.TYPE.DELETED_TRANSACTIONS:
                    this.$root.$emit("deleted_transactions:refresh");
                    break;
                case CREPORT.TYPE.TRANSACTIONS_DETAIL:
                    this.$root.$emit("transactions_detail:refresh");
                    break;
                case CREPORT.TYPE.PROFIT_MARGIN:
                    this.$root.$emit("profit-margins:refresh");
                    break;
                case CREPORT.TYPE.ARR:
                    this.$root.$emit(
                        "account-receivable-reconciliation:refresh"
                    );
                    break;
                case CREPORT.TYPE.DISCOUNT_DETAILS:
                    this.$root.$emit("discount-details:refresh");
                    break;
                case CREPORT.TYPE.DISCOUNTS_SUMMARY:
                    this.$root.$emit("discount-summary:refresh");
                    break;
                case CREPORT.TYPE.DONATIONS_DETAILS:
                    this.$root.$emit("donations-details:refresh");
                    break;
                case CREPORT.TYPE.ITEMS_BY_PRICE_TYPE:
                    this.$root.$emit("items-by-price-type:refresh");
                    break;
                case CREPORT.TYPE.AR_OUT_OF_PERIOD_SALES:
                    this.$root.$emit("ar-out-of-period-sales:refresh");
                    break;
                case CREPORT.TYPE.CARDS_STORED_ON_FILE:
                    this.$root.$emit("cards-stored-on-file:refresh");
                    break;
                case CREPORT.TYPE.PAYMENT_BY_PROVIDER:
                    this.$root.$emit("payment-by-provider:refresh");
                    break;
                case CREPORT.TYPE.APPOINTMENT_LOG:
                    this.$root.$emit("appointment-log:refresh");
                    break;
                case CREPORT.TYPE.INVENTORY_LOG:
                    this.$root.$emit("inventory-log:refresh");
                    break;
                case CREPORT.TYPE.CREDITS_APPLIED:
                    this.$root.$emit("credits-applied:refresh");
                    break;
                case CREPORT.TYPE.PRODUCTION_CREDIT_BY_SALES:
                    this.$root.$emit("sales-production-credit-detail:refresh");
                    break;
                case CREPORT.TYPE.PRODUCTION_CREDIT_BY_PAYMENTS:
                    this.$root.$emit(
                        "payments-production-credit-detail:refresh"
                    );
                    break;
                case CREPORT.TYPE.ACTIVE_ENGAGED_PATIENT:
                    this.$root.$emit("active_engaged_patient:refresh");
                    break;
                case CREPORT.TYPE.SALES_BY_PROVIDER_SUMMARY:
                    this.$root.$emit("sales-provider-summary:refresh");
                    break;
                case CREPORT.TYPE.NEW_ENGAGED_CLIENTS:
                    this.$root.$emit("new_engaged_clients:refresh");
                    break;
                case CREPORT.TYPE.PETCARE_CLIENT_LIST:
                    this.$root.$emit("petcare_client_list:refresh");
                    break;
                case CREPORT.TYPE.APPOINTMENT_DURATION:
                    this.$root.$emit("appointment-duration:refresh");
                    break;
                default:
                    this.$root.$emit("report-filter-date-range:refresh");
                    break;
            }
        },
        petcareToggleFilter(data) {
            this.petcareReport.is_active_users = data.is_active_users;
            this.petcareReport.interval_month = data.interval_month;
            this.petcareReport.to = data.to;
        }
    }
};
</script>

<style type="text/css" scoped>
.disabled-icon {
    color: grey;
    filter: grayscale(100%);
}
.fw-normal {
    font-weight: normal;
}
</style>
